import {Conversation} from '@stripe-internal/conversations-client';

import {LiveChatTopBar} from './LiveChatTopBar';
import {RACTopBar} from './RACTopBar/RACTopBar';
import {
  useCurrentConversation,
  useVisibility,
} from '../../../core/hooks/appHooks';
import {useLiveChannelStatus} from '../hooks/useLiveChannelStatus';

function ConversationTopBar({conversation}: {conversation: Conversation}) {
  const {visibility} = useVisibility();
  const {isLiveChatActive, isRACActive} = useLiveChannelStatus(conversation);

  if (visibility !== 'open') {
    return null;
  }

  if (isLiveChatActive) {
    return <LiveChatTopBar conversation={conversation} />;
  } else if (isRACActive) {
    return <RACTopBar conversation={conversation} />;
  } else {
    return null;
  }
}

export function ActiveTopBar() {
  const currentConversation = useCurrentConversation();

  if (!currentConversation) {
    return null;
  }

  return <ConversationTopBar conversation={currentConversation} />;
}
